@if (isLoading()) {
	<mat-progress-bar mode="indeterminate"></mat-progress-bar>
} @else {
	@if (isEditing()) {
		<mat-form-field [matTooltip]="tooltip()" appearance="outline" subscriptSizing="dynamic">
			@switch (inputType()) {
				@case ('textarea') {
					<textarea
						matInput
						[(ngModel)]="editValue"
						[disabled]="isLoading()"
						#inputModel="ngModel"
						(keydown)="onKeydown($event)"
						rows="3"
					></textarea>
				}
				@case ('mail') {
					<input
						type="text"
						matInput
						[(ngModel)]="editValue"
						[disabled]="isLoading()"
						appMailList
						#inputModel="ngModel"
						(keydown)="onKeydown($event)"
					/>
				}
				@case ('date') {
					<input
						matInput
						[ngModel]="editDateForPicker()"
						(ngModelChange)="setEditDate($event)"
						[matDatepicker]="datePicker"
						[disabled]="isLoading()"
						(keydown)="onKeydown($event)"
						(click)="datePicker.open()"
					/>
					<mat-datepicker #datePicker></mat-datepicker>
				}
				@case ('select') {
					<mat-select
						[ngModel]="editValue()"
						(ngModelChange)="editValue.set($event)"
						[disabled]="isLoading()"
						(keydown)="onKeydown($event)"
					>
						<mat-option [value]="null">-</mat-option>
						@for (opt of options(); track opt.id) {
							<mat-option [value]="opt.id">{{ opt.name }}</mat-option>
						}
					</mat-select>
				}
				@default {
					<input
						[type]="inputType()"
						matInput
						[(ngModel)]="editValue"
						[disabled]="isLoading()"
						[pattern]="pattern()"
						#inputModel="ngModel"
						[class.invalid-input]="inputModel.invalid && inputModel.touched"
						(keydown)="onKeydown($event)"
					/>
				}
			}
			<button (click)="confirmEdit()" mat-icon-button matSuffix class="fs-6" color="primary">
				<i class="fa-solid fa-check"></i>
			</button>
		</mat-form-field>
	} @else {
		<span class="w-75">{{ displayValue() || '-' }}</span>
		<span class="w-25">
			<button (click)="startEdit()" class="fs-6 m-2" mat-icon-button color="primary">
				<i class="fa-solid fa-pen"></i>
			</button>
		</span>
	}
}
